import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import {SurveyModalController} from './SurveyModal.controller';
import classNames from 'classnames';

import './SurveyModal.scss';
import {SurveyModalHeader} from './components/SurveyModalHeader';
import {SurveyModalContent} from './components/SurveyModalContent';
import {SurveyModalToolbar} from './components/SurveyModalToolbar';

export interface SurveyModalProps {
    ctrl: SurveyModalController;
}

// Main Component
@observer
export class SurveyModal extends TechseeBaseComponent<SurveyModalProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        const modalClassName = classNames('survey-modal', {
            'new-header-and-footer': true
        });

        return (
            <GenericModal
                className={modalClassName}
                header={() => <SurveyModalHeader ctrl={ctrl} />}
                content={() => <SurveyModalContent ctrl={ctrl} />}
                toolbar={() => <SurveyModalToolbar ctrl={ctrl} />}
                onHideHandler={ctrl.close}
                show={ctrl.isVisible}
                closeOnEscape={false}
            />
        );
    }
}
